// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-area-stacked';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm3 10 3.188 4 4.25-3 3.187 3L20 16v3H3v-9Zm0-5.5 3.188 4 4.25-3 3.187 3 6.375 2v3l-6.375-2-3.188-3-4.25 3L3 7.5v-3Z' />
);

export const viewBox = '0 0 22 22';
